import {
  Component, Input, OnInit, OnDestroy,
  ViewChild, Inject, Renderer2,
} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import * as _ from 'lodash';

import { UserService } from 'shared/user/user.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { User } from 'shared/user/user';
import { AccountDropdownComponent } from 'shared/account/account-dropdown/account-dropdown.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';

import { dashboardModel } from './dashboard.model';
import { rightPanelNavs } from './right-panel-navs';
import {ProductPanelComponent} from '../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'sd-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {

  user: User = new User();
  model = dashboardModel;
  commentsVisible: boolean = false;
  versions: any;
  showSidedrawer: boolean = true; // use this field to show sidedrawer
  rightPanelNavs: Array<any> = rightPanelNavs;

  @ViewChild(AccountDropdownComponent, {static: false}) accountDropdown: AccountDropdownComponent | void;

  @ViewChild(DynamicNavsComponent, {static: true})
  dynamicNavs: DynamicNavsComponent | void;

  constructor(
    private userService: UserService,
    private router: Router,
    private permissionsService: PermissionsService,
    private _renderer: Renderer2,
    @Inject(DOCUMENT) private document: any,
  ) {}

  // getters
  get userName() {
    return this.user.first_name;
  }

  get lastUpdate() {
    return 'September 14th, 2017';
  }

  // hooks
  ngOnInit() {
    this.refreshUser();
    // add avaliability to html-tag to adopt to media-queries
    this._renderer.addClass(document.documentElement, 'media-on');
    _.defer(() => this.dynamicNavs && this.dynamicNavs.selectNav('comments'));
  }

  ngOnDestroy() {
    // remove avaliability from html-tag to adopt to media-queries
    this._renderer.removeClass(document.documentElement, 'media-on');
    this._renderer.removeClass(document.body, 'fullscreen');
    _.each(this.rightPanelNavs, (item: any) => {
      item.active = false;
    });
  }

  // public
  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  // handlers
  onCommentsShowClick(event: any) {
    this.commentsVisible = true;
    this._renderer.addClass(document.body, 'fullscreen');
  }

  onRightPanelClose() {
    this.commentsVisible = false;
    this._renderer.removeClass(document.body, 'fullscreen');
  }

  // private
  private refreshUser() {
    this.userService.getUser()
    .subscribe((user: any) => {
      this.user = user;
    });
  }

}
